// import Terms from "../components/terms_privacy/Terms.vue";
// import Privacy from "../components/terms_privacy/Privacy.vue";
import TermsPrivacy from "../components/terms_privacy/Terms_Privacy.vue";


export default [
  // {name: 'Terms', path: '/terms', component: Terms,},
  // { name: 'Privacy', path: '/privacy', component: Privacy,  },
  {name: 'TermsPrivacy', path: '/termsandprivacy', component: TermsPrivacy,}
]
